export default __webpack_public_path__ + "static/magnifier-a915494b7eedb7df2d589c26d0f0b96e.svg";